import React, { useState } from "react";
import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Typography,
} from "@material-ui/core/";
import { useSelector } from "react-redux";

const AppBarUserIcon = ({ handleLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const user = useSelector((state) => state?.auth?.user);
  const name = user?.username;
  const image = user?.image;

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div
      align="right"
      className="d-flex align-items-center justify-content-center"
    >
      <Box>
        <Typography variant="body2">Welcome, {name}</Typography>
      </Box>
      <IconButton
        aria-label="Account"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <Avatar src={image} />
      </IconButton>
      <Menu
        id="menu-appbar"
        className="mt-5"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
};

export default AppBarUserIcon;
